module.exports = __webpack_public_path__ + "static/favicon-36987933b55284eea7f60b51e29a2a75.png";